import type { ReactNode } from 'react';
import { makeStyles } from '@material-ui/core/styles';

// CR-1115: hide the "Edit" (pencil) IconButton in the catalog index table
// ACTIONS column. Same reason as CustomAboutCard: users should not be
// redirected to catalog-info.yaml on GitHub from the UI; catalog changes
// go through the catalog automation PR flow.
// material-table renders action icons with `title="<name>"` on a wrapping span,
// AboutCard uses `aria-label="<name>"` on the IconButton. Cover both patterns.
// Hides both "Edit" (pencil) and "View" (external link) — both redirect to
// catalog-info.yaml on GitHub, which users should not reach from the UI.
const useStyles = makeStyles({
  root: {
    display: 'contents',
    '& [aria-label="Edit"]': {
      display: 'none',
    },
    '& [title="Edit"]': {
      display: 'none',
    },
    '& [aria-label="View"]': {
      display: 'none',
    },
    '& [title="View"]': {
      display: 'none',
    },
  },
});

export const CustomCatalogIndexPage = ({ children }: { children: ReactNode }) => {
  const classes = useStyles();
  return <div className={classes.root}>{children}</div>;
};
